import { j as e } from "./react-944c88e2.js";
import { Box as r, Text as i, OrderedList as t, ListItem as s, UnorderedList as c } from "@chakra-ui/react";
const l = {
  title: "General Inquiries",
  description: "Please select your inquiry below",
  options: ["File a service request", "Device Eligibility"]
}, a = {
  title: "Tech Support",
  description: "You can select an option, or ask a different question",
  options: [
    "Device Request & Delivery Related",
    "Data backup before swap",
    "Retrieve Device IMEI",
    "Turn off FMIP before Swap",
    "Screen crack",
    "Tech Support",
    "Setup my device or device settings"
  ]
}, d = {
  title: "General Inquiries",
  description: "Please select your inquiry below",
  options: ["Purchase Related", "Service Related", "Repair Related", "Termination"]
}, u = {
  title: "Tech Support",
  description: "You can select an option, or ask a different question",
  options: [
    "Malfunction",
    "Speaker Issue",
    "Power Issue",
    "Connectivity",
    "Data Transfer",
    "Camera Issue",
    "Memory Related",
    "App Related"
  ]
}, h = "Thank you for your message. Our Tech Specialists are unavailable right now. Please chat with us between 9am – 9pm, Mondays to Sundays.", y = "Thank you for your message. Our Tech Specialists are unavailable right now. Please chat with us between 9am – 6pm, Mondays to Sundays.", p = "Alternatively, you can request a callback by leaving your contact details. Our Tech Specialists will contact you during operating hours.", v = "Thank you for your message. Our Tech Specialists are unavailable right now. Please chat with us between 9am – 9pm, Mondays to Sundays.", f = "Thank you for your message. Our Tech Specialists are unavailable right now. Please chat with us between 9am – 6pm, Mondays to Sundays.", x = "Alternatively, you can request a callback by leaving your contact details. Our Tech Specialists will contact you during operating hours.", j = [
  {
    question: "How do I file a service request?",
    answer: /* @__PURE__ */ e.jsxs(r, { children: [
      /* @__PURE__ */ e.jsx(i, { mb: 2, children: "You can file your service request via the service portal in 3 easy steps:" }),
      /* @__PURE__ */ e.jsxs(t, { px: 3, children: [
        /* @__PURE__ */ e.jsx(s, { children: "Select the enrolled device" }),
        /* @__PURE__ */ e.jsx(c, { children: /* @__PURE__ */ e.jsx(s, { children: "If the device is not yet registered, you can do so before you start your service" }) }),
        /* @__PURE__ */ e.jsx(s, { children: "Schedule for pickup of your device" }),
        /* @__PURE__ */ e.jsx(s, { children: "Select the enrolled device" })
      ] })
    ] })
  },
  {
    question: "How long does it take for my service request to be processed?",
    answer: /* @__PURE__ */ e.jsxs(r, { children: [
      /* @__PURE__ */ e.jsx(i, { mb: 2, children: "You can file your service request via the service portal in 3 easy steps:" }),
      /* @__PURE__ */ e.jsxs(t, { px: 3, children: [
        /* @__PURE__ */ e.jsx(s, { children: "Select the enrolled device" }),
        /* @__PURE__ */ e.jsx(c, { children: /* @__PURE__ */ e.jsx(s, { children: "If the device is not yet registered, you can do so before you start your service" }) }),
        /* @__PURE__ */ e.jsx(s, { children: "Schedule for pickup of your device" }),
        /* @__PURE__ */ e.jsx(s, { children: "Select the enrolled device" })
      ] })
    ] })
  },
  {
    question: "Is there a limit on the number of service requests I can file?",
    answer: /* @__PURE__ */ e.jsxs(r, { children: [
      /* @__PURE__ */ e.jsx(i, { mb: 2, children: "You can file your service request via the service portal in 3 easy steps:" }),
      /* @__PURE__ */ e.jsxs(t, { px: 3, children: [
        /* @__PURE__ */ e.jsx(s, { children: "Select the enrolled device" }),
        /* @__PURE__ */ e.jsx(c, { children: /* @__PURE__ */ e.jsx(s, { children: "If the device is not yet registered, you can do so before you start your service" }) }),
        /* @__PURE__ */ e.jsx(s, { children: "Schedule for pickup of your device" }),
        /* @__PURE__ */ e.jsx(s, { children: "Select the enrolled device" })
      ] })
    ] })
  },
  {
    question: "How do I track the status of my service requests?",
    answer: /* @__PURE__ */ e.jsxs(r, { children: [
      /* @__PURE__ */ e.jsx(i, { mb: 2, children: "You can file your service request via the service portal in 3 easy steps:" }),
      /* @__PURE__ */ e.jsxs(t, { px: 3, children: [
        /* @__PURE__ */ e.jsx(s, { children: "Select the enrolled device" }),
        /* @__PURE__ */ e.jsx(c, { children: /* @__PURE__ */ e.jsx(s, { children: "If the device is not yet registered, you can do so before you start your service" }) }),
        /* @__PURE__ */ e.jsx(s, { children: "Schedule for pickup of your device" }),
        /* @__PURE__ */ e.jsx(s, { children: "Select the enrolled device" })
      ] })
    ] })
  },
  {
    question: "I have filed my service request, so what do I do next?",
    answer: /* @__PURE__ */ e.jsxs(r, { children: [
      /* @__PURE__ */ e.jsx(i, { mb: 2, children: "You can file your service request via the service portal in 3 easy steps:" }),
      /* @__PURE__ */ e.jsxs(t, { px: 3, children: [
        /* @__PURE__ */ e.jsx(s, { children: "Select the enrolled device" }),
        /* @__PURE__ */ e.jsx(c, { children: /* @__PURE__ */ e.jsx(s, { children: "If the device is not yet registered, you can do so before you start your service" }) }),
        /* @__PURE__ */ e.jsx(s, { children: "Schedule for pickup of your device" }),
        /* @__PURE__ */ e.jsx(s, { children: "Select the enrolled device" })
      ] })
    ] })
  },
  {
    question: "Do I need to be home for pick-up and delivery of device?",
    answer: /* @__PURE__ */ e.jsxs(r, { children: [
      /* @__PURE__ */ e.jsx(i, { mb: 2, children: "You can file your service request via the service portal in 3 easy steps:" }),
      /* @__PURE__ */ e.jsxs(t, { px: 3, children: [
        /* @__PURE__ */ e.jsx(s, { children: "Select the enrolled device" }),
        /* @__PURE__ */ e.jsx(c, { children: /* @__PURE__ */ e.jsx(s, { children: "If the device is not yet registered, you can do so before you start your service" }) }),
        /* @__PURE__ */ e.jsx(s, { children: "Schedule for pickup of your device" }),
        /* @__PURE__ */ e.jsx(s, { children: "Select the enrolled device" })
      ] })
    ] })
  },
  {
    question: "Can I reschedule my pick-up or return service?",
    answer: /* @__PURE__ */ e.jsxs(r, { children: [
      /* @__PURE__ */ e.jsx(i, { mb: 2, children: "You can file your service request via the service portal in 3 easy steps:" }),
      /* @__PURE__ */ e.jsxs(t, { px: 3, children: [
        /* @__PURE__ */ e.jsx(s, { children: "Select the enrolled device" }),
        /* @__PURE__ */ e.jsx(c, { children: /* @__PURE__ */ e.jsx(s, { children: "If the device is not yet registered, you can do so before you start your service" }) }),
        /* @__PURE__ */ e.jsx(s, { children: "Schedule for pickup of your device" }),
        /* @__PURE__ */ e.jsx(s, { children: "Select the enrolled device" })
      ] })
    ] })
  }
];
export {
  f as C,
  v as a,
  x as b,
  y as c,
  h as d,
  p as e,
  u as f,
  l as g,
  d as h,
  j as s,
  a as t
};
